import { IApplicationState } from '../../types/redux';

export function getAdvantages(state: IApplicationState) {
  return state.newbuilding.advantages;
}
